<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "TicketSetting"
}
</script>

<style scoped>

</style>